<ion-button
  *ngIf="badge"
  class="loyalty-badge button-round"
  type="button"
  [ngClass]="[size, variant, badge.name | lowercase, badge.color]"
  [attr.aria-label]="badge.ariaLabel || badge.name"
  [style.backgroundColor]="badge.color"
  (click)="openModal()"
>
  <img
    *ngIf="badge.icon; else alternativeIcon"
    class="icon"
    aria-hidden="true"
    alt=""
    [src]="badge.icon"
  />
  <ng-template #alternativeIcon>
    <div class="alternative-icon font-weight-semi-bold">
      {{ badge.name }}
    </div>
  </ng-template>
  <div
    *ngIf="variant === 'full' && badge.icon"
    class="label font-weight-semi-bold"
  >
    {{ badge.name }}
  </div>
</ion-button>

<ion-modal
  class="loyalty-badge-modal"
  [isOpen]="isModalOpen"
  (didDismiss)="dismissModal()"
>
  <ng-template>
    <app-loyalty-badge-modal
      [badgeName]="badge.name"
      (onDismiss)="dismissModal()"
    />
  </ng-template>
</ion-modal>
